module.exports = __webpack_public_path__ + "static/media/1.ba90ce3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/3029/1.jpg
// module id = 650
// module chunks = 0